export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
export const REALTIME_ANALYTICS_URL = process.env.REACT_APP_REALTIME_ANALYTICS_URL;